'use client';
import { IServerContext, ServerEnvContext } from '../context/ServerEnvContext';

export default function ServerEnvProvider({
  env,
  children,
}: {
  env: IServerContext;
  children: React.ReactNode;
}) {
  return (
    <ServerEnvContext.Provider value={env}>
      {children}
    </ServerEnvContext.Provider>
  );
}
